/* eslint-disable import/prefer-default-export */
import EVENTS from '@/utils/Constants/Events';
import Logger from '@/utils/Logger';

let bodyInfo = {};

export const closeModal = popup => {
  if (!popup) popup = document.querySelector('.dln-popup.dln-popup--open');
  if (!popup) Logger.error('no modal found, close is not possible');
  DLG.EVE.emit(EVENTS.MODAL.CLOSE, { popup });
};

export const lockBodyScroll = () => {
  setTimeout(() => {
    bodyInfo = {
      overflowY: document.body.style.overflowY,
      height: document.body.style.height,
      paddingRight: document.body.style.paddingRight,
      position: document.body.style.position,
    };
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.overflowY = 'hidden';
    document.body.style.height = '100vh';
    document.body.style.paddingRight = '15px';
    document.body.style.position = 'fixed';
  }, 300);
};

export const unlockBodyScroll = () => {
  const scrollY = document.body.style.top;
  document.body.style.overflowY = bodyInfo.overflowY || '';
  document.body.style.height = bodyInfo.height || '';
  document.body.style.paddingRight = bodyInfo.paddingRight || '';
  document.body.style.position = '';
  document.body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
};
